<template>
  <div class="fc-invoices">
    <!-- Header con Icono de Cierre -->
    <header class="fc-modal__head">
      <div class="fc-modal__side fc-modal__side--left">
        <v-btn @click="back" v-if="e1 === 2" outlined small color="error" class="fc-back-btn">
          <v-icon left size="18">mdi-chevron-left</v-icon>
          Volver
        </v-btn>
        <span class="fc-modal__eyebrow">
          <v-icon size="16" color="primary">{{ type ? 'mdi-cash-multiple' : 'mdi-cash-register' }}</v-icon>
          {{ type ? 'Cobranza' : 'Pago' }}
        </span>
      </div>

      <div class="fc-modal__center">
        <h1 class="fc-modal__title">{{ title }}</h1>
        <span class="fc-modal__entity">{{ localInvoices[0]?.entity_name }}</span>
      </div>

      <div class="fc-modal__side fc-modal__side--right">
        <v-icon
          size="26"
          class="fc-modal__close"
          :color="hoverClose ? 'error' : 'grey darken-1'"
          @mouseover="hoverClose = true"
          @mouseleave="hoverClose = false"
          @click="$emit('close')"
        >
          mdi-close
        </v-icon>
      </div>
    </header>

    <!-- Stepper Principal -->
    <v-row justify="center" class="mt-0 pt-0">
      <v-col md="12" class="pa-0">
        <v-stepper v-model="e1" class="elevation-0 rounded-lg pa-0 my-0">
          <v-stepper-items class="pa-0">
            <!-- Paso 1 -->
            <v-stepper-content step="1" class="py-0 my-0">
              <div class="fc-kpis fc-kpis--compact pt-4">
                <!-- Cantidad de Facturas -->
                <article class="fc-kpi fc-kpi--primary">
                  <div class="fc-kpi__top">
                    <span class="fc-kpi__icon"><v-icon size="22" color="primary">mdi-file-document-multiple-outline</v-icon></span>
                  </div>
                  <span class="fc-kpi__label">Cantidad Facturas</span>
                  <div class="fc-kpi__values">
                    <div class="fc-kpi__money"><span class="fc-kpi__number">{{ localInvoices.length }}</span></div>
                  </div>
                </article>

                <!-- Por Cobrar / Por Pagar -->
                <article class="fc-kpi" :class="type ? 'fc-kpi--warning' : 'fc-kpi--info'">
                  <div class="fc-kpi__top">
                    <span class="fc-kpi__icon">
                      <v-icon size="22" :color="type ? 'warning' : 'info'">{{ type ? 'mdi-account-cash' : 'mdi-account-arrow-left' }}</v-icon>
                    </span>
                  </div>
                  <span class="fc-kpi__label">{{ type ? "Por Cobrar" : "Por Pagar" }}</span>
                  <div class="fc-kpi__values">
                    <div v-for="(item, i) in getHeader('porCobrar')" :key="i" class="fc-kpi__money">
                      <span class="fc-kpi__number">{{ currencyFormat(item.total_amount) }}</span>
                      <span class="fc-kpi__currency">{{ item.currency_code }}</span>
                    </div>
                  </div>
                </article>

                <!-- Notas de Crédito -->
                <article class="fc-kpi fc-kpi--error">
                  <div class="fc-kpi__top">
                    <span class="fc-kpi__icon"><v-icon size="22" color="error">mdi-credit-card-minus-outline</v-icon></span>
                  </div>
                  <span class="fc-kpi__label">Notas de Crédito</span>
                  <div class="fc-kpi__values">
                    <div class="fc-kpi__money"><span class="fc-kpi__number">{{ currencyFormat(0) }}</span></div>
                  </div>
                </article>

                <!-- Cobrado -->
                <article class="fc-kpi fc-kpi--success">
                  <div class="fc-kpi__top">
                    <span class="fc-kpi__icon"><v-icon size="22" color="success">mdi-cash-check</v-icon></span>
                  </div>
                  <span class="fc-kpi__label">Cobrado</span>
                  <div class="fc-kpi__values">
                    <div v-for="(item, i) in getHeader('paid_amount')" :key="i" class="fc-kpi__money">
                      <span class="fc-kpi__number">{{ currencyFormat(item.total_amount) }}</span>
                      <span class="fc-kpi__currency">{{ item.currency_code }}</span>
                    </div>
                  </div>
                </article>
              </div>

              <!-- Botones de filtro -->
              <v-row class="mb-3 px-3" align="center" justify="center">
                <v-col md="4" align="start" class="pa-0">
                   <!-- Botón cancelar -->
                  <v-btn @click="back" outlined rounded-lg small color="error" dense v-if="e1 === 1">
                     <v-icon left>mdi-chevron-left</v-icon>
                     Cancelar
                   </v-btn>
                </v-col>
               <v-col md="4" align="center" justify="center" class="pa-0">
                 <v-btn-toggle
                   v-model="seleted_currencies"
                   class="rounded-lg elevation-1"
                   mandatory
                   color="primary"
                   @change="onCurrencyChange"
                 >
                   <v-btn
                     v-for="(item, i) of currencies"
                     :key="i"
                     :value="item.id"
                     small
                     outlined
                   >
                     {{ item.code }}
                   </v-btn>
                 </v-btn-toggle>
               </v-col>

                <v-col md="4" align="end"  class="pa-0">

                       <v-menu bottom origin="center center" transition="scale-transition">
                         <template v-slot:activator="{ on, attrs }">
                           <v-btn
                             class="ml-2 rounded-lg"
                             color="success"
                             dark dense small
                             outlined
                             v-bind="attrs"
                             v-on="on"
                           >                         
                             <v-icon class="ml-2">mdi-download</v-icon>
                           </v-btn>
                         </template>
                         <v-list>
                           <v-list-item @click="generatePDF()">
                             <v-list-item-icon>
                               <v-icon color="red">mdi-file-pdf-box</v-icon>
                             </v-list-item-icon>
                             <v-list-item-title>PDF</v-list-item-title>
                           </v-list-item>
                           <v-list-item @click="generateExcel()">
                             <v-list-item-icon>
                               <v-icon color="success">mdi-file-excel-box</v-icon>
                             </v-list-item-icon>
                             <v-list-item-title>Excel</v-list-item-title>
                           </v-list-item>
                         </v-list>
                       </v-menu>

                      <v-btn class="ml-2"
                        :disabled="!(e1 == 1 && seleted_currencies > 0) || selected.length === 0"
                        @click="next"
                        color="primary"
                        outlined small dense
                        rounded-lg
                      >
                        Siguiente
                        <v-icon right>mdi-chevron-right</v-icon>
                      </v-btn>

                </v-col>
              </v-row>

              <!-- Tabla de facturas -->
              <div class="fc-card fc-card--table">
                <v-data-table
                  v-if="!loading"
                  :value="selected"
                  @item-selected="enterSelect($event, 1)"
                  @toggle-select-all="enterSelect($event, 2)"
                  height="45vh"
                  dense fixed-header
                  hide-default-footer
                  :page.sync="page"
                  @page-count="pageCount = $event"
                  v-model="selected"
                  :show-select="seleted_currencies !== 0"
                  :search="search"
                  :headers="headers"
                  :items="allInvoices"
                  :items-per-page="100"
                  class="fc-data-table elevation-0"
                  item-key="invoice_number"
                >
                  <template v-slot:top>
                    <v-toolbar class="elevation-0 rounded-lg">
                      <v-row align="center" justify="center">
                        <v-col md="4">
                          <span class="font-weight-medium">{{ allInvoices.length }} facturas</span>
                           <v-badge
                              color="red"
                              overlap
                              dot
                              :value="user_group.length > 0 || branches_group.length > 0"
                            >
                              <v-btn icon class="pa-1" @click="dialog_settings = true">
                                <v-icon>mdi-cog</v-icon>
                              </v-btn>
                            </v-badge>
                        </v-col>
                        <v-col md="4">
                            <v-text-field
                            label="Buscar..."
                              class="ma-0"
                              v-model="search"
                              outlined
                              dense
                              hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col md="4" align="end">
                          <span v-if="seleted_currencies != 0" class="mx-5 success--text">
                            Total seleccionado:
                            <b>${{ currencyFormat(totalSelected) }}</b>
                            {{ getSelectedCurrencyCode() }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-toolbar>
                  </template>

                  <!-- Número de factura con hover -->
                  <template v-slot:[`item.invoice_number`]="{ item }">
                    <v-hover v-slot="{ hover }">
                      <span
                        @click="showInvoice(item.invoice_id, true)"
                        class="font-weight-medium text-truncate"
                        :style="{
                          color: hover ? '#1976D2' : 'black',
                          cursor: hover ? 'pointer' : '',
                          'text-decoration': hover ? 'underline' : '',
                        }"
                      >
                        {{ item.invoice_number }}
                      </span>
                    </v-hover>
                  </template>

                  <!-- Formato de montos -->
                  <template v-slot:[`item.total_amount`]="{ item }">
                    <span>{{ currencyFormat(item.total_amount) }} {{ item.currency_code }}</span>
                  </template>
                  <template v-slot:[`item.pending_amount`]="{ item }">
                    <span class="red--text">
                      {{ currencyFormat(getDisplayAmount(item, "pending_amount")) }}
                      {{ getDisplayCurrency(item) }}
                    </span>
                  </template>
                  <template v-slot:[`item.total_paid`]="{ item }">
                    <span>{{ currencyFormat(item.total_paid) }} {{ item.currency_code }}</span>
                  </template>
                  <template v-slot:[`item.total_to_pay`]="{ item }">
                    <span>{{ currencyFormat(item.total_to_pay) }} {{ item.currency_code }}</span>
                  </template>

                  <!-- Campo editable de pago -->
                  <template v-slot:[`item.paid`]="{ item }">
                    <div>
                      <v-text-field
                        :disabled="item.total_amount - item.total_paid < 1"
                        :max="getMaxPayableAmount(item)"
                        :value="item.paid || 0"
                        @input="updatePaid(item, $event)"
                        :readonly="seleted_currencies == 0"
                        prefix="$"
                        :suffix="getDisplayCurrency(item)"
                        type="number"
                        step="0.01"
                        dense hide-details
                        outlined
                        class="rounded-lg my-1"
                      ></v-text-field>

                      <v-text-field
                        v-if="showBaseField(item)"
                        :value="item.paid_base || 0"
                        @input="updatePaidBase(item, $event)"
                        prefix="$"
                        :suffix="item.original_currency_code"
                        type="number"
                        step="0.01"
                        dense
                        outlined
                        class="mt-1 rounded-lg"
                        style="font-size: 0.8em"
                        :label="`Base (${item.original_currency_code})`"
                      ></v-text-field>
                    </div>
                  </template>

                  <!-- Vencimiento -->
                  <template v-slot:[`item.expire_at`]="{ item }">
                    <span v-if="item.expire_at != null" :class="getDateColor(item)">
                      {{ getDate(item.expire_at) }}
                    </span>
                  </template>

                  <!-- Estado -->
                  <template v-slot:[`item.status_id`]="{ item }">
                    <v-chip
                      small
                      outlined
                      color="success"
                      v-if="item.total_amount - item.total_paid < 1"
                    >
                      <span v-if="!type">Cobrado</span>
                      <span v-else>Por Pagar</span>
                    </v-chip>
                    <v-chip v-else small outlined color="error">
                      <span v-if="type">Por Cobrar</span>
                      <span v-else>Por Pagar</span>
                    </v-chip>
                  </template>

                  <!-- Acciones -->
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          @click="viewInvoices(item)"
                          color="success"
                          class="mx-2 mt-n2"
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-cash-plus
                        </v-icon>
                      </template>
                      <span>Agregar pago</span>
                    </v-tooltip>
                  </template>

                  <!-- Footer -->
                  <template slot="footer">
                    <v-row justify="center" class="mb-2">
                      <v-container style="width: 70%" class="mt-1">
                        <v-pagination v-model="page" :length="pageCount"></v-pagination>
                      </v-container>
                    </v-row>
                  </template>
                </v-data-table>
              </div>
            </v-stepper-content>
            <!-- Paso 2: Checkout -->
            <v-stepper-content step="2" class="py-0 my-0">
              <CheckOutCxCVue
                v-if="e1 === 2"
                @close="$emit('close')"
                :data="invoiceSelectedWithCurrency"
                @updatePriceCurrency="updatePriceCurrency"
                @remove-invoice="removeInvoiceFromSelected"
                :type="type ? 2 : 1"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
    </v-row>

    <!-- Dialog Configuración -->
    <v-dialog v-model="dialog_settings" width="30%">
      <v-card rounded="lg">
        <v-card-title class="font-weight-bold">Otros filtros</v-card-title>
        <v-card-text>
          <v-row justify="center">
            <span class="subtitle-2 grey--text">Agrupar por usuarios</span>
          </v-row>
          <v-row align="center" justify="center">
            <v-col md="10">
              <v-autocomplete
                v-model="user_group"
                outlined
                multiple
                dense
                hide-details
                no-data-text="No hay facturas"
                :items="users"
                label="Usuarios"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-row justify="center" class="mt-4">
            <span class="subtitle-2 grey--text">Agrupar por sucursal</span>
          </v-row>
          <v-row align="center" justify="center">
            <v-col md="10">
              <v-autocomplete
                v-model="branches_group"
                outlined
                multiple
                dense
                hide-details
                no-data-text="No hay facturas"
                :items="branches"
                label="Sucursales"
                class="rounded-lg"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="success" class="rounded-lg" @click="dialog_settings = false">
            Aceptar
          </v-btn>
          <v-btn text color="error" class="rounded-lg" @click="cancel_settings()">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import "jspdf-autotable";

import CheckOutCxCVue from "./CheckOutCxC.vue";

export default {
  components: { CheckOutCxCVue },
  data: () => ({
    loaded: false,
    hoverClose: false,
    currencies: [],
    page: 1,
    pageCount: 0,
    seleted_currencies: null,
    pending_pay: true,
    isAll: false,
    dialog_settings: false,
    selected: [],
    user_group: [],
    branches_group: [],
    invoiceSelected: [],
    search: "",
    amount_disturb: 0,
    e1: 1,
    localInvoices: [], // Copia local reactiva de los datos
    loading: false,
    currencyRates: {}, // Almacenar tasas de cambio
  }),
  props: {
    data_invoices: {
      type: Array,
      default: [],
    },
    type: {
      type: Boolean,
    },
    title: {
      type: String,
    },
    filters: {
      type: Object,
    },
  },
  watch: {
    // Observar cambios en el prop para actualizar la copia local
    data_invoices: {
      handler(newVal) {
        this.localInvoices = newVal.map((invoice) => ({
          ...invoice,
          // CRÍTICO: paid_base es la referencia inmutable en moneda original
          paid_base: invoice.paid || 0, // Valor en moneda original (NUNCA CAMBIA excepto si usuario lo edita)
          paid: invoice.paid || 0, // Valor en moneda seleccionada (se calcula desde paid_base)
          currency_rate: 1, // Tasa de cambio actual
          original_currency_id: invoice.currency_id, // ID moneda original
          original_currency_code: invoice.currency_code, // Código moneda original
          // Asegurar que total_to_pay esté definido
          total_to_pay: invoice.total_to_pay || invoice.total_amount || 0,
        }));
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getData();
  },

  computed: {
    headers() {
      if (this.type == false) {
        return [
          { text: "Factura", value: "invoice_number", align: "start" },
          { text: "Sucursal", value: "entity_branch_name" },
          { text: "Vencimineto", value: "expire_at" },
          { text: "Total factura", value: "total_amount" },
          { text: "Total a pagar ", value: "total_to_pay" },
          { text: "Total Pagado", value: "total_paid", align: "end" },
          {
            text: "Balance pendiente",
            value: "pending_amount",
            align: "end",
          },
          { text: "Abono", value: "paid", align: "center", width: "15%" },
        ];
      } else {
        return [
          { text: "Factura", value: "invoice_number", align: "start" },
          { text: "Sucursal", value: "entity_branch_name" },
          { text: "Vencimineto", value: "expire_at" },
          { text: "Total factura", value: "total_amount" },
          { text: "Total a cobrar ", value: "total_to_pay" },
          { text: "Total cobrado", value: "total_paid", align: "end" },
          {
            text: "Balance pendiente",
            value: "pending_amount",
            align: "end",
          },
          { text: "Abono", value: "paid", align: "center", width: "15%" },
        ];
      }
    },
    allInvoices() {
      let invoices = this.localInvoices;
      if (this.seleted_currencies != 0) {
        invoices = invoices.filter(
          (invoice) => invoice.currency_id === this.seleted_currencies
        );
      }
      if (this.user_group.length > 0) {
        invoices = invoices.filter((element) =>
          this.user_group.includes(element.created_by)
        );
      }
      if (this.branches_group.length > 0) {
        invoices = invoices.filter((element) =>
          this.branches_group.includes(element.entity_branch_id)
        );
      }
      return invoices;
    },
    // Computed property para el total seleccionado que se actualiza automáticamente
    totalSelected() {
      return this.selected.reduce((total, item) => {
        const paidAmount = parseFloat(item.paid) || 0;
        return total + paidAmount;
      }, 0);
    },
    // Computed para preparar las facturas seleccionadas con toda la info de conversión
    invoiceSelectedWithCurrency() {
      return this.invoiceSelected.map((invoice) => ({
        ...invoice,
        // Asegurar que tenga toda la información necesaria para el checkout
        paid_base: invoice.paid_base || 0,
        paid: invoice.paid || 0,
        currency_rate: invoice.currency_rate || 1,
        original_currency_id: invoice.original_currency_id,
        original_currency_code: invoice.original_currency_code,
      }));
    },
    users() {
      const uniqueUsers = this.localInvoices.reduce((acc, invoice) => {
        if (!acc.some((users) => users.value === invoice.created_by)) {
          acc.push({
            text: invoice.use_fullname,
            value: invoice.created_by,
          });
        }
        return acc;
      }, []);
      return uniqueUsers;
    },
    branches() {
      const uniqueUsers = this.localInvoices.reduce((acc, invoice) => {
        if (!acc.some((users) => users.value === invoice.entity_branch_id)) {
          acc.push({
            text: invoice.entity_branch_name,
            value: invoice.entity_branch_id,
          });
        }
        return acc;
      }, []);
      return uniqueUsers;
    },
  },
  methods: {
    // Obtener la moneda que se debe mostrar
    getDisplayCurrency(item) {
      if (this.seleted_currencies === 0) {
        return item.original_currency_code;
      }
      const selectedCurrency = this.currencies.find(
        (c) => c.id === this.seleted_currencies
      );
      return selectedCurrency ? selectedCurrency.code : item.original_currency_code;
    },

    // Obtener el código de la moneda seleccionada para el total
    getSelectedCurrencyCode() {
      if (this.seleted_currencies === 0) return "";
      const selectedCurrency = this.currencies.find(
        (c) => c.id === this.seleted_currencies
      );
      return selectedCurrency ? selectedCurrency.code : "";
    },

    // Mostrar el campo base solo si hay conversión de moneda
    showBaseField(item) {
      return (
        this.seleted_currencies !== 0 &&
        this.seleted_currencies !== item.original_currency_id &&
        (item.paid_base > 0 || item.paid > 0)
      );
    },

    // Obtener el monto a mostrar según la moneda seleccionada
    getDisplayAmount(item, field) {
      if (
        this.seleted_currencies === 0 ||
        this.seleted_currencies === item.original_currency_id
      ) {
        return item[field];
      }
      // Si hay conversión, multiplicar por la tasa
      return item[field] * (item.currency_rate || 1);
    },

    // Obtener el máximo monto que se puede pagar
    getMaxPayableAmount(item) {
      const maxBase = item.total_amount - item.total_paid;
      if (
        this.seleted_currencies === 0 ||
        this.seleted_currencies === item.original_currency_id
      ) {
        return maxBase;
      }
      return maxBase * (item.currency_rate || 1);
    },

    // CRÍTICO: Actualizar el campo paid principal
    updatePaid(item, value) {
      const numericValue = parseFloat(value) || 0;
      const maxValue = this.getMaxPayableAmount(item);
      // CORRECCIÓN: Solo limitar si el valor excede el máximo, no asignar el máximo automáticamente
      const finalValue = numericValue > maxValue ? maxValue : numericValue;

      // Actualizar paid (valor en moneda seleccionada)
      this.$set(item, "paid", finalValue);

      // REGLA CRÍTICA: Solo actualizar paid_base si estamos en la moneda original
      if (
        this.seleted_currencies === 0 ||
        this.seleted_currencies === item.original_currency_id
      ) {
        // Estamos en la moneda original: paid_base = paid
        this.$set(item, "paid_base", finalValue);
      }
      // Si estamos en moneda diferente, NO tocar paid_base
      // porque se debe mantener como referencia inmutable

      this.updateSelection(item, finalValue);
    },

    // Actualizar el campo paid_base directamente
    updatePaidBase(item, value) {
      const numericValue = parseFloat(value) || 0;
      const maxBaseValue = item.total_amount - item.total_paid;
      const finalBaseValue = numericValue > maxBaseValue ? maxBaseValue : numericValue;

      // Actualizar paid_base (referencia inmutable)
      this.$set(item, "paid_base", finalBaseValue);

      // Recalcular paid desde paid_base
      this.calculatePaidFromBase(item);

      this.updateSelection(item, item.paid);
    },

    // Calcular paid desde paid_base (dirección correcta)
    calculatePaidFromBase(item) {
      if (
        this.seleted_currencies === 0 ||
        this.seleted_currencies === item.original_currency_id
      ) {
        // Misma moneda: paid = paid_base
        this.$set(item, "paid", item.paid_base);
      } else if (item.currency_rate) {
        // Diferente moneda: paid = paid_base * rate
        const convertedValue = item.paid_base * item.currency_rate;
        this.$set(item, "paid", convertedValue);
      }
    },

    // Manejar la selección automática
    updateSelection(item, finalValue) {
      if (finalValue > 0) {
        if (!this.selected.find((selected) => selected.invoice_id === item.invoice_id)) {
          this.selected.push(item);
        }
      } else {
        const index = this.selected.findIndex(
          (selected) => selected.invoice_id === item.invoice_id
        );
        if (index !== -1) {
          this.selected.splice(index, 1);
        }
      }
    },

    // CRÍTICO: Manejar cambio de moneda sin alterar paid_base
    async onCurrencyChange() {
      if (this.seleted_currencies === 0) {
        // Modo "TODAS": mostrar en moneda original
        this.localInvoices.forEach((item) => {
          this.$set(item, "currency_rate", 1);
          // paid = paid_base (mostrar valor original)
          this.$set(item, "paid", item.paid_base);
        });
        return;
      }

      // Obtener moneda seleccionada
      const selectedCurrency = this.currencies.find(
        (c) => c.id === this.seleted_currencies
      );
      if (!selectedCurrency) return;

      // Procesar cada factura
      for (const item of this.localInvoices) {
        if (this.seleted_currencies === item.original_currency_id) {
          // Misma moneda que la original: no hay conversión
          this.$set(item, "currency_rate", 1);
          this.$set(item, "paid", item.paid_base);
        } else {
          // Diferente moneda: obtener tasa y convertir desde paid_base
          // SOLO si paid_base > 0 (para preservar valores ingresados por el usuario)
          if (item.paid_base > 0) {
            await this.updateCurrencyRate(item, selectedCurrency);
          } else {
            // Solo actualizar la tasa sin cambiar paid si no hay paid_base
            await this.updateCurrencyRateOnly(item, selectedCurrency);
          }
        }
      }
    },

    // Obtener y actualizar tasa de cambio para una factura
    async updateCurrencyRate(item, selectedCurrency) {
      try {
        const data = {
          business_unit_id: item.business_unit_id,
          effective_date: new Date().toISOString().split("T")[0],
          currency_invoice_id: item.original_currency_id,
          currency_to: selectedCurrency.id,
        };

        const response = await this.api_Post("accounting/currenciesByInvoice", data);
        if (response.status === 200) {
          const rateData = await response.json();
          const rate = rateData.length > 0 ? parseFloat(rateData[0].value) : 1;

          this.$set(item, "currency_rate", rate);
          // CRÍTICO: Siempre convertir desde paid_base
          const convertedPaid = item.paid_base * rate;
          this.$set(item, "paid", convertedPaid);
        }
      } catch (error) {
        console.error("Error getting currency rate:", error);
        this.$set(item, "currency_rate", 1);
        this.$set(item, "paid", item.paid_base);
      }
    },

    // Obtener tasa de cambio sin modificar el valor paid (preservar input del usuario)
    async updateCurrencyRateOnly(item, selectedCurrency) {
      try {
        const data = {
          business_unit_id: item.business_unit_id,
          effective_date: new Date().toISOString().split("T")[0],
          currency_invoice_id: item.original_currency_id,
          currency_to: selectedCurrency.id,
        };

        const response = await this.api_Post("accounting/currenciesByInvoice", data);
        if (response.status === 200) {
          const rateData = await response.json();
          const rate = rateData.length > 0 ? parseFloat(rateData[0].value) : 1;

          this.$set(item, "currency_rate", rate);
          // NO modificar item.paid para preservar el valor ingresado por el usuario
        }
      } catch (error) {
        console.error("Error getting currency rate:", error);
        this.$set(item, "currency_rate", 1);
        // NO modificar item.paid para preservar el valor ingresado por el usuario
      }
    },

    async generatePDF() {
      const doc = new jsPDF();
      let invoices = this.seleted_currencies == 0 ? this.localInvoices : this.allInvoices;

      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");
      doc.text(`Cuentas por Cobrar (${this.localInvoices[0]?.entity_name})`, 105, 20, {
        align: "center",
      });

      doc.setFontSize(12);
      doc.setFont("helvetica", "normal");
      doc.text(`Cantidad de Facturas: ${invoices.length}`, 10, 30);

      let offsetY = 40;
      const totals = invoices.reduce((acc, invoice) => {
        const currencyCode = invoice.currency_code;
        const total = parseFloat(invoice.pending_amount);
        acc[currencyCode] = (acc[currencyCode] || 0) + total;
        return acc;
      }, {});

      Object.entries(totals).forEach(([currencyCode, total]) => {
        doc.text(
          `Por Cobrar (${currencyCode}): ${this.currencyFormat(total)}`,
          10,
          offsetY
        );
        offsetY += 10;
      });

      offsetY += 10;

      doc.autoTable({
        head: [
          [
            "Factura",
            "Cotización",
            "Fecha",
            "Vencimiento",
            "Total Factura",
            "Total a Cobrar",
            "Total Cobrado",
            "Balance Pendiente",
          ],
        ],
        body: invoices.map((invoice) => [
          invoice.invoice_number,
          invoice.quotation_number || "N/A",
          moment(invoice.emission_date.slice(0, 10)).format("DD/MM/YYYY"),
          moment(invoice.expire_at.slice(0, 10)).format("DD/MM/YYYY"),
          this.currencyFormat(invoice.total_amount) + " " + invoice.currency_code,
          this.currencyFormat(invoice.total_to_pay) + " " + invoice.currency_code,
          this.currencyFormat(invoice.total_paid) + " " + invoice.currency_code,
          this.currencyFormat(invoice.pending_amount) + " " + invoice.currency_code,
        ]),
        startY: offsetY,
        styles: {
          fontSize: 9,
          cellPadding: 2,
        },
        headStyles: {
          fillColor: [41, 128, 185],
          textColor: [255, 255, 255],
          halign: "center",
        },
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 37 },
          2: { cellWidth: 20 },
          3: { cellWidth: 20 },
          4: { cellWidth: 24, halign: "right" },
          5: { cellWidth: 24, halign: "right" },
          6: { cellWidth: 23, halign: "right" },
          7: { cellWidth: 25, halign: "right" },
        },
        margin: { left: 4, right: 14 },
        didDrawPage: (data) => {
          doc.setFontSize(9);
          doc.text(`Página ${data.pageNumber}`, 200, 290, { align: "right" });
        },
      });

      doc.save(`cuentas_por_cobrar_${this.localInvoices[0]?.entity_name}.pdf`);
    },

    async generateExcel() {
      let invoices = this.allInvoices;
      const tipo_cuenta = [2,3].includes(invoices[0]?.invoice_type_id) ? "cobrar" : "pagar";
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet(`Cuentas por ${tipo_cuenta}`);

      worksheet.mergeCells("A1:G1");
      worksheet.getCell(
        "A1"
      ).value = `Cuentas por ${tipo_cuenta} ( ${this.localInvoices[0]?.entity_name} )`;
      worksheet.getCell("A1").font = { size: 16, bold: true };
      worksheet.getCell("A1").alignment = { horizontal: "center" };

      const totals = invoices.reduce((acc, invoice) => {
        const currencyCode = invoice.currency_code;
        const total = parseFloat(invoice.pending_amount);
        acc[currencyCode] = (acc[currencyCode] || 0) + total;
        return acc;
      }, {});

      worksheet.getCell("A3").value = `Cantidad Facturas: ${invoices.length}`;
      let totalRowIndex = 4;
      Object.entries(totals).forEach(([currencyCode, total]) => {
        worksheet.getCell(
          `A${totalRowIndex}`
        ).value = `Por ${tipo_cuenta} ${currencyCode}: ${total.toFixed(2)}`;
        totalRowIndex++;
      });

      const type_relation_number = {
        text: "Numero suplidor",
        value: "supplier_invoice_number",
      };
      if ([2,3].includes(invoices[0]?.invoice_type_id)) {
        type_relation_number.text = "Cotizacion";
        type_relation_number.value = "quotation_number";
      }

      worksheet
        .addRow([
          "Sucursal",
          "Factura",
          type_relation_number.text,
          "Moneda",
          "Fecha creacion",
          "Vencimiento",
          "Total factura",
          `Total a ${tipo_cuenta}`,
          `Total ${tipo_cuenta == "cobrar" ? "cobrado" : "pagado"}`,
          "Balance pendiente",
          "Abono",
          "Responsable",
        ])
        .eachCell((cell) => {
          cell.font = { bold: true };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFCCCCCC" },
          };
        });

      invoices.forEach((invoice) => {
        worksheet.addRow([
          invoice.entity_branch_name,
          invoice.invoice_number,
          invoice[type_relation_number.value] || "N/A",
          invoice.currency_code,
          invoice.created_date,
          invoice.expire_at.slice(0, 10),
          invoice.total_amount,
          invoice.total_to_pay,
          invoice.total_paid,
          invoice.pending_amount,
          invoice.paid_base || "0.00",
          invoice.use_fullname,
        ]);
      });

      worksheet.columns.forEach((column) => {
        column.width = 20;
      });

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `cuentas_por_${tipo_cuenta}_${this.localInvoices[0]?.entity_name}.xlsx`;
      link.click();
      window.URL.revokeObjectURL(url);
    },

    async getData() {
      this.loading = true;
      this.currencies = await this.g_currencies();
      this.currencies.unshift({ id: 0, code: "TODAS", currency_name: "TODOS" });
      this.seleted_currencies = 0;
      this.loading = false;
    },

    updatePriceCurrency(invoice) {
      this.invoiceSelected.forEach((element) => {
        if (element.invoice_id == invoice.invoice_id) {
          element.new_pending_amount = invoice.new_pending_amount;
          element.rate = invoice.rate;
          element.paid_base = invoice.paid_base;
          
          // Solo actualizar paid si el usuario no ha ingresado un valor personalizado
          // o si el valor actual es 0 o igual al monto pendiente anterior
          if (!element.paid || element.paid === 0 || element.paid === element.pending_amount) {
            element.paid = parseFloat(invoice.new_pending_amount);
          }
          // Si el usuario ya ingresó un valor, preservarlo
        }
      });
    },

    back() {
      this.loaded = true;
      this.loaded = false;

      if (this.e1 == 1) {
        this.$emit("close");
      }
      if (this.e1 == 2) {
        this.e1 = 1;
      }
    },

    compararPorFecha(a, b) {
      const fechaA = new Date(a.emission_date);
      const fechaB = new Date(b.emission_date);

      if (fechaA < fechaB) {
        return -1;
      }
      if (fechaA > fechaB) {
        return 1;
      }
      return 0;
    },

    enterSelect(item, type) {
      if (type == 1) {
        let isPresent = this.selected.some(
          (selectedInv) => selectedInv.invoice_id === item.item.invoice_id
        );
        if (isPresent) {
          let index = this.selected.findIndex(
            (selectedInv) => selectedInv.invoice_id === item.item.invoice_id
          );
          this.selected.splice(index, 1);
          // Resetear tanto paid como paid_base
          this.$set(item.item, "paid", 0);
          this.$set(item.item, "paid_base", 0);
        } else {
          let maxAmount = item.item.total_amount - item.item.total_paid;

          // CRÍTICO: paid_base siempre en moneda original
          this.$set(item.item, "paid_base", maxAmount);

          // paid según la moneda seleccionada
          if (
            this.seleted_currencies === 0 ||
            this.seleted_currencies === item.item.original_currency_id
          ) {
            this.$set(item.item, "paid", maxAmount);
          } else {
            const rate = item.item.currency_rate || 1;
            this.$set(item.item, "paid", maxAmount * rate);
          }
        }
      } else if (type == 2) {
        if (item.value == true) {
          // Seleccionar todos
          this.localInvoices.forEach((invoice) => {
            if (this.allInvoices.includes(invoice)) {
              const maxAmount =
                parseFloat(invoice.total_amount) - parseFloat(invoice.total_paid);

              // CRÍTICO: paid_base siempre en moneda original
              this.$set(invoice, "paid_base", maxAmount);

              if (
                this.seleted_currencies === 0 ||
                this.seleted_currencies === invoice.original_currency_id
              ) {
                this.$set(invoice, "paid", maxAmount);
              } else {
                const rate = invoice.currency_rate || 1;
                this.$set(invoice, "paid", maxAmount * rate);
              }
            }
          });
        } else {
          // Deseleccionar todos
          this.localInvoices.forEach((invoice) => {
            this.$set(invoice, "paid", 0);
            this.$set(invoice, "paid_base", 0);
          });
          this.selected = [];
        }
      }
    },

    next() {
      this.loaded = true;
      this.loaded = false;
      if (this.e1 == 1) {
        this.invoiceSelected = [];
        for (let item of this.localInvoices) {
          if (parseFloat(item.paid_base) > 0) {
            // SOLUCIÓN: Pasar la referencia directa para mantener reactividad
            // No crear copia nueva que rompe la sincronización entre componentes
            this.invoiceSelected.push(item);
          }
        }
        if (this.invoiceSelected.length > 0) {
          this.e1 = 2;
        } else {
          this.$toast.warning("Debes asignarle un monto");
        }
      }
    },

    formatNumber(number) {
      let n = parseFloat(number).toFixed(2);
      return parseFloat(n).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    unformatNumber(number) {
      return number.replace(/,/g, "").replace(/\./g, "");
    },

    getDate(item) {
      return moment(item).format("DD/MM/YYYY");
    },

    getHeader(type) {
      let result = [];

      if (type == "paid_amount") {
        this.localInvoices.reduce(function (res, value) {
          if (!res[value.currency_code]) {
            res[value.currency_code] = {
              currency_code: value.currency_code,
              total_amount: 0,
            };
            result.push(res[value.currency_code]);
          }

          res[value.currency_code].total_amount += parseFloat(value.total_paid || 0);
          return res;
        }, {});
      }
      if (type == "porCobrar") {
        this.localInvoices.reduce(function (res, value) {
          if (!res[value.currency_code]) {
            res[value.currency_code] = {
              currency_code: value.currency_code,
              total_amount: 0,
            };
            result.push(res[value.currency_code]);
          }

          res[value.currency_code].total_amount += parseFloat(value.total_to_pay || 0);
          return res;
        }, {});
      }

      return result;
    },

    getDateColor(item) {
      const now = moment();
      const end = moment(item.expire_at);
      if (item.total_amount - item.total_paid < 1) {
        return;
      }

      if (moment(now.format("YYYY/MM/DD")).isAfter(moment(end.format("YYYY/MM/DD")))) {
        return "red--text";
      }
    },

    cancel_settings() {
      this.user_group = [];
      this.branches_group = [];
      this.dialog_settings = false;
    },
    removeInvoiceFromSelected(item) {
      const index = this.invoiceSelected.findIndex(i => i.invoice_id === item.invoice_id);
      if (index !== -1) this.invoiceSelected.splice(index, 1);
      const indexSel = this.selected.findIndex(i => i.invoice_id === item.invoice_id);
      if (indexSel !== -1) this.selected.splice(indexSel, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
// ── Palette aligned with the Vuetify theme (teal primary, MD tokens) ──
$ink:        #2A3547;
$muted:      #5A6A85;
$muted-soft: #8A98AB;
$rule:       #E5EAF2;
$bg:         #F7F9FC;
$card:       #FFFFFF;

$primary:      #00897B;
$primary-soft: #E0F2F1;
$info:         #2196F3;
$info-soft:    #E3F2FD;
$warning:      #F57F17;
$warning-soft: #FFF3E0;
$success:      #2E7D32;
$success-soft: #E8F5E9;
$error:        #E53935;
$error-soft:   #FFEBEE;

$shadow:    rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 12%) 0px 8px 18px -6px;
$shadow-lg: rgb(145 158 171 / 20%) 0px 0px 2px 0px, rgb(145 158 171 / 16%) 0px 14px 28px -6px;
$font: 'Plus Jakarta Sans', sans-serif;

.fc-invoices {
  font-family: $font;
  color: $ink;
  background: $bg;
  min-height: 100%;
  padding: clamp(14px, 1.8vw, 26px) clamp(14px, 2.4vw, 34px) 40px;
}

// ── MODAL HEAD ───────────────────────────────────────────────
.fc-modal__head {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 16px;
  padding: 4px 4px 18px;
}
.fc-modal__side { display: flex; align-items: center; gap: 12px; }
.fc-modal__side--right { justify-content: flex-end; }
.fc-modal__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .06em;
  text-transform: uppercase;
  color: $primary;
}
.fc-modal__center { text-align: center; line-height: 1.15; }
.fc-modal__title {
  font-family: $font;
  font-size: clamp(20px, 2.4vw, 26px);
  font-weight: 700;
  letter-spacing: -.01em;
  color: $ink;
  margin: 0;
}
.fc-modal__entity {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: $muted;
  margin-top: 2px;
}
.fc-modal__close { cursor: pointer; transition: transform .15s ease; }
.fc-modal__close:hover { transform: scale(1.12); }
.fc-back-btn,
::v-deep .fc-back-btn { font-family: $font; text-transform: none; letter-spacing: 0; border-radius: 9px; }

// ── CARD ─────────────────────────────────────────────────────
.fc-card {
  background: $card;
  border: 1px solid $rule;
  border-radius: 14px;
  box-shadow: $shadow;
}
.fc-card--table { overflow: hidden; }

// ── KPI ──────────────────────────────────────────────────────
.fc-kpis {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}
.fc-kpis--compact { gap: 14px; margin-bottom: 4px; }
.fc-kpi {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px 18px 14px;
  background: $card;
  border: 1px solid $rule;
  border-radius: 14px;
  box-shadow: $shadow;
  overflow: hidden;
  transition: transform .2s ease, box-shadow .2s ease;
}
.fc-kpi:hover { transform: translateY(-3px); box-shadow: $shadow-lg; }
.fc-kpi__top { display: flex; align-items: center; justify-content: space-between; }
.fc-kpi__icon {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
}
.fc-kpi--primary .fc-kpi__icon { background: $primary-soft; }
.fc-kpi--warning .fc-kpi__icon { background: $warning-soft; }
.fc-kpi--info    .fc-kpi__icon { background: $info-soft; }
.fc-kpi--success .fc-kpi__icon { background: $success-soft; }
.fc-kpi--error   .fc-kpi__icon { background: $error-soft; }
.fc-kpi__label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: $muted;
}
.fc-kpi__values { display: flex; flex-direction: column; gap: 2px; }
.fc-kpi__money { display: flex; align-items: baseline; gap: 6px; }
.fc-kpi__number {
  font-size: 21px;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -.02em;
  color: $ink;
}
.fc-kpi__currency { font-size: 12px; font-weight: 700; color: $muted-soft; text-transform: uppercase; }

// ── Vuetify deep overrides ───────────────────────────────────
/* Estilos para el campo base más pequeño */
::v-deep .v-text-field--outlined.v-input--dense .v-input__control {
  min-height: 32px;
}
.mi-clase-sin-padding {
  padding: 0 !important;
}

::v-deep .fc-data-table {
  background: transparent;

  .v-toolbar { background: #F7F9FC !important; border-bottom: 1px solid $rule; }
  .v-data-table-header th {
    background: #F7F9FC;
    color: $muted !important;
    font-weight: 700 !important;
    font-size: 11px !important;
    letter-spacing: .04em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  td { font-family: $font; color: $ink; }
  td, th { border-bottom: 1px solid $rule !important; }
  tbody tr:hover { background: $primary-soft !important; }
}
</style>
